module.exports = __webpack_public_path__ + "static/avatar-d17e8a51d6c9277597ec5e18eaed5048.jpg";